/* Alt sabit navigasyon — thumb zone, 5 sekme, kayan aktif gösterge. */

import type { Lang } from "../../shared/types.js";
import { ui } from "../lib/i18n.js";
import { IconClock, IconHanger, IconMic, IconMoon, IconSpark } from "./Icons.js";
import type { TabId } from "../tabs.js";
import { TABS } from "../tabs.js";

const ICONS = {
  program: IconClock,
  dresscode: IconHanger,
  atolyeler: IconSpark,
  aksam: IconMoon,
  konusmacilar: IconMic,
} as const;

interface Props {
  active: TabId;
  lang: Lang;
  onSelect: (id: TabId) => void;
}

export function BottomNav({ active, lang, onSelect }: Props) {
  const index = TABS.findIndex((t) => t.id === active);

  return (
    <nav className="nav" aria-label={lang === "tr" ? "Bölümler" : "Sections"}>
      <div className="nav__inner" role="tablist">
        <span
          className="nav__marker"
          style={{ transform: `translateX(${Math.max(0, index) * 100}%)` }}
          aria-hidden="true"
        />
        {TABS.map((tab) => {
          const Icon = ICONS[tab.id];
          const selected = tab.id === active;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={selected}
              aria-controls={`panel-${tab.id}`}
              className="nav__btn pressable"
              onClick={() => onSelect(tab.id)}
            >
              <Icon />
              <span className="nav__label">{ui(tab.labelKey, lang)}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
